import { SmallBadge } from "./SmallBadge";
import type { CustomTagProps } from "rc-select/lib/BaseSelect";
import { StyledText } from "../assets/typography/typography";
import { colors } from "./colors";
import { css } from "@emotion/react";

const additionalStyling = css`
  margin-right: 4px;
`;

export const SelectedItemBadge = ({ label, onClose }: CustomTagProps) => {
  return (
    <SmallBadge onClose={onClose} additionalStyles={additionalStyling}>
      <StyledText
        className="bodySubtextRegular mb-0"
        onClick={onClose}
        color={colors.textPrimary}
      >
        {label}
      </StyledText>
    </SmallBadge>
  );
};
